// extracted by mini-css-extract-plugin
export default {"price":"UZwh6","selected":"JIH41"};